import { render, staticRenderFns } from "./SmartLists.vue?vue&type=template&id=5df58502&"
import script from "./SmartLists.vue?vue&type=script&lang=js&"
export * from "./SmartLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports